import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import { TextArea } from '../../components/Inputs/TextArea'
import Button from '../../components/General/Button'
import Select from '../../components/Inputs/Select'
import Empty from '../../components/Display/Empty'
import InputCheck from '../../components/Inputs/InputCheck'
import FieldArrayAutocomplete from '../../components/Inputs/FieldArrayAutocomplete'
import EmptyBox from '../../assets/animations/empty_box.json'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { FiTrash2 } from 'react-icons/fi'
import axios from 'axios'
import { IFoodOrder } from 'safe'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const server = process.env.REACT_APP_SERVER_URL
export const AddProduct: React.FC<AddProductProps> = ({
  onSubmit,
  onClose,
  useType,
  isLoading,
  defaultValues,
  tables,
  onLoad,
}) => {

  const [items, setItems] = useState<any[]>([])

  const refDivScroll = useRef<HTMLDivElement | null>(null)

  const warehouses = useSelector((state: RootState) => state.warh.warehouses)

  const { addAlert } = useSnackBars()

  const warehouseId = useMemo(() => {
    return warehouses.find((warehouse) => warehouse.warehouseType === 'SALE FLOOR')?.id
  }, [warehouses])
  
  const form = useForm<IFormFoodOrder>({
    defaultValues: {
      // idFoodTable: defaultValues?.idFoodTable || '',
      // type: defaultValues?.type || 'delivery',
    },
  })

  const addItem = async (values: any) => {
    try {
      addAlert({
        message: 'Cargando',
        status: 'loading',
      })

      const newItemsArray = [...new Array(+values?.amount)].map((_, index) => {
        axios.post(`${server}/food-order/item`, {
          idFoodOrder: defaultValues?.id,
          idItem: values?.value?.id,
          quantity: 1,
          type: values?.value?.type
        })
      })

      await Promise.all(newItemsArray)

      const newItemsLocal = [...new Array(+values?.amount)].map((_, index) => ({
        idFoodOrder: defaultValues?.id,
        idItem: values?.value?.id,
        // quantity: 1,
        type: values?.value?.type,
        amount: 1,
        name: values?.value?.name
      }))
      setItems([...items, ...newItemsLocal])
      // setItems([...items, {...values?.value, amount: values?.amount}])
      addAlert({
        message: 'Artículo asignado correctamente',
        status: 'success',
      })
    } catch (error) {
      addAlert({
        message: 'Error al asignar artículo',
        status: 'error',
      })
    }
  }

  const loadInventory = () => {
    // console.log(mockItemsLoaded)
    // if (items.length > 0) onLoad(items, accounting)
  }

  const onDeleteItem = async (item: any) => {
    try {
      let resp = await axios.delete(`${server}/food-order/item?id=${item?.id}`)
      setItems(items.filter((x) => x.idItem !== item.idItem))
      addAlert({
        message: 'Artículo eliminado correctamente',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: 'Error al eliminar artículo',
        status: 'error',
      })
    }
  }

  useEffect(() => {
    if (defaultValues?.items) {
      // setItems(defaultValues?.items?.map((item: any) => ({...item, amount: item.quantity})))
    }
  }, [defaultValues])

  return (
    <div>
    <h1 className="mb-3">Asignar artículos</h1>
    <div className="max-h-80 overflow-y-auto" ref={refDivScroll}>
      {items.length > 0 &&
        items.map((item) => (
          <div
            className="bg-gray-100 dark:bg-gray-800 rounded-lg my-4 p-2 flex justify-between items-center"
            key={item.idItem}
          >
            <div className="truncate">
              <h1 className="text-sm ml-3">{item.name}</h1>
              <div className="flex items-center mt-2">
              <h1 className="text-sm ml-3">
               Cantidad:
              </h1>
              <h1 className="text-sm ml-1">
                {item.amount}
              </h1>
              </div>
             
            </div>

          </div>
        ))}
    </div>

    {items.length === 0 && (
      <Empty
        animationProps={{
          height: 200,
          width: 200,
          animation: EmptyBox,
        }}
        lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
      >
        <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
          Agrega artículos para asignarlos a la comanda
        </p>
      </Empty>
    )}
   
    <div className="grid grid-cols-12 gap-x-6 gap-y-2">
      <FieldArrayAutocomplete
        url={`inventory/existence?id=${warehouseId}&sale=true&pageNumber=${1}&pageSize=${10}`}
        secondUrl={`service?pageNumber=1&pageSize=10`}
        queryParam="fastSearch"
        secondQueryParam="name"
        valuesToCompare={items}
        onChangeValue={addItem}
        useCase="LOAD"
        bodyGet="items"
        bodyGetSecond="services"
        isFromAddProduct={true}
      />
    </div>
    {/* <div className="flex space-x-2 mt-3 px-1 block">
      {onClose && (
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>
      )}
      <Button
        type="primary"
        classes={`w-1/2 mr-4 ${
          items.length === 0 && 'opacity-20 cursor-default'
        }`}
        htmlType="button"
        onClick={loadInventory}
      >
        Aceptar
      </Button>
    </div> */}
  </div>
  )
}

interface AddProductProps {
  onSubmit: (data: IFormFoodOrder) => void
  onClose: () => void
  useType?: 'create' | 'edit' | 'watch'
  isLoading?: boolean
  defaultValues?: IFoodOrder
  tables: {value: string, text: string}[]
  onLoad: (items: any[], accounting: boolean) => void
}

export interface IFormFoodOrder {
  idFoodTable: string
  type: string
  observations: string | null
}
